import React from 'react';
import { Header as SharedHeader } from '@spotify-internal/masthead-react';
import styled from 'styled-components';

import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { useMastheadData } from 'providers/MastheadProvider';
import { TurnkeyNavBar } from 'components/Masthead/Header';
import { MastheadVariants } from 'utils/vertical';

import S4AHeader from './S4AHeader';

interface ContainerProps {
  transparent?: boolean;
}

const PLAIN_DATA = {
  navigation: {
    brand: {
      href: '#',
      alt: 'Spotify',
    },
  },
};

const Container = styled.div<ContainerProps>`
  a[href='#'] {
    cursor: default;
  }

  header {
    ${props => props.transparent && 'background: transparent !important;'}
  }
`;

const Gradient = styled.div`
  position: absolute;
  width: 100%;
  height: 200px;
  z-index: -1;
  background: linear-gradient(98.85deg, rgba(18, 18, 18, 0.3) 0%, var(--background-base) 100%),
    linear-gradient(180deg, rgba(18, 18, 18, 0) 0%, var(--background-base) 100%), var(--text-bright-accent);
`;

export const Header = () => {
  const { header, turnkeyHeader, useTurnkeyMasthead } = useMastheadData();
  const {
    verticalConfig: { features },
    market: { preferredDir },
  } = useServerSideConstants();

  const { showHeaderGradient, configureMasthead } = features;

  const useTurnkeyHeader =
    configureMasthead?.header === MastheadVariants.TURNKEY || (useTurnkeyMasthead && !configureMasthead);

  const useSharedHeader = !configureMasthead && useTurnkeyMasthead === false;

  const headerProps = header ?? PLAIN_DATA;

  const renderHeader = () => {
    if (configureMasthead?.header === MastheadVariants.S4A) {
      return <S4AHeader />;
    }

    if (useTurnkeyHeader && turnkeyHeader) {
      return <TurnkeyNavBar data={turnkeyHeader} />;
    }

    if (useSharedHeader) {
      return (
        <div dir={preferredDir}>
          <SharedHeader {...headerProps} fixed={false} transparent={showHeaderGradient} />
        </div>
      );
    }

    return null;
  };

  return (
    <Container transparent={showHeaderGradient}>
      {showHeaderGradient && <Gradient aria-hidden="true" />}
      {renderHeader()}
    </Container>
  );
};
